import React from 'react';

const Navbar = ({currentYear, onYearChange, setSidebarOpen}) => {
    const handleYearInput = (e) => {
        onYearChange(e.target.value);
    };

    return (
        <nav className="bg-white shadow-sm border-b border-gray-200">
            <div className="px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between h-16">
                    <div className="flex items-center">
                        {/* Botón hamburguesa para móvil */}
                        <button
                            className="md:hidden -ml-2 mr-2 p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500"
                            onClick={() => setSidebarOpen(true)}>
                            <span className="sr-only">Abrir sidebar</span>
                            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M4 6h16M4 12h16M4 18h16"/>
                            </svg>
                        </button>
                    </div>

                    {/* Curso Actual - VERSIÓN MINIMALISTA */}
                    <div className="flex items-center space-x-4">
                        <div className="flex items-center">
                            <label htmlFor="current-year" className="mr-2 text-sm text-gray-600">
                                Curso Académico:
                            </label>
                            <input
                                type="number"
                                id="current-year"
                                min="2025"
                                max="2035"
                                value={currentYear}
                                onChange={handleYearInput}
                                className="w-20 px-3 py-1 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 sm:text-sm text-center"/>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
